import { LanguageType } from '@app/constants/interfaces/interfaces'

type Language = {
  id: number
  name: LanguageType
  title: string
  countryCode: string
}

export const languages: Language[] = [
  {
    id: 1,
    name: 'en',
    title: 'English',
    countryCode: 'gb',
  },
  {
    id: 2,
    name: 'pl',
    title: 'Polski',
    countryCode: 'pl',
  },
]
